import React, { useState } from "react";
import { AppBar, IconButton, Drawer, Box, } from "@mui/material";
import { IconMenu2 } from "@tabler/icons-react";

import Navbar from "./navbar";

import { useScreenSize } from "@context/screenSizeContext";

import Logo from "@assets/logo/zhushan-logo.png"

export default function Header() {
  const isSmallScreen = useScreenSize();
  const [open, setOpen] = useState(false);  // navbar


  return (
    <>
      <AppBar
        position="static"
        style={{
          width: "100%",
          height: "60px",
          backgroundColor: "#FFFFFF",
          display: "flex",
          justifyContent: "center",
          paddingLeft: 40,
          paddingRight: 40,
          boxShadow: "none",
          borderBottom: "1px solid #E5E5E5",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <img src={Logo} width={70} alt='Zhu Shan'/>
          {isSmallScreen &&
            <IconButton onClick={() => setOpen(open === true ? false : true)}>
              <IconMenu2 color="#5D5D5D" />
            </IconButton> 
          }
        </div>
      </AppBar>

      <Drawer open={open} onClose={() => setOpen(false)}>
        <Box sx={{ width: 300, height: "100%" }}>
          <Navbar
            setOpen={setOpen}
            isDrawer={true}
          />
        </Box>
      </Drawer>
    </>
  );
}